import { useEffect, useState } from "react";
import {
  getSellerOrgBuildConfig,
  isOrganizationBrandingLoaded,
  subscribeSellerOrgBranding,
  type SellerOrgBuildConfig,
} from "../config/sellerOrgConfig";

/**
 * Seller org config for the active build, merged with organization API branding when loaded.
 */
export function useSellerOrgConfig(): SellerOrgBuildConfig {
  const [, setRevision] = useState(0);

  useEffect(() => subscribeSellerOrgBranding(() => setRevision((n) => n + 1)), []);

  return getSellerOrgBuildConfig();
}

/** True after GET /organization/{code} branding has been applied. */
export function useOrganizationBrandingLoaded(): boolean {
  const [, setRevision] = useState(0);

  useEffect(() => subscribeSellerOrgBranding(() => setRevision((n) => n + 1)), []);

  return isOrganizationBrandingLoaded();
}
